import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect, useMemo, useRef, useState } from 'react';
import "./style/index.css";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function Carousel(props, ref) {
  var {
    position = 0,
    direction = 'horizontal',
    width = 400,
    height = 200,
    palyTime = 2000,
    scrollTime = 200,
    autoPlay = true,
    afterChange,
    beforeChange,
    prefixCls = 'w-carousel',
    className,
    style
  } = props;
  var cls = useMemo(() => [prefixCls, className].filter(Boolean).join(' ').trim(), [prefixCls, className]);
  var [currentPosition, currentPositionSet] = useState(position);
  var [transitionInner, transitionInnerSet] = useState(scrollTime * 0.001 + "s ease-in-out");
  var positionRef = useRef(currentPosition);
  var childCount = React.Children.count(props.children) + 1;
  var _stopPlay = useRef({
    stop: () => {},
    after: afterChange,
    before: beforeChange
  });
  React.useImperativeHandle(ref, () => ({
    gotoSlide,
    prevSlide: () => gotoSlide(positionRef.current - 1),
    nextSlide: () => gotoSlide(positionRef.current + 1),
    stopPlay: () => _stopPlay.current.stop()
  }), [ref]);
  var gotoSlide = slidNumber => {
    _stopPlay.current.stop();
    var maxSlid = childCount - 1;
    var slidNumberTemp = slidNumber > maxSlid ? maxSlid : slidNumber;
    slidNumberTemp = slidNumber < 0 ? 0 : slidNumberTemp;
    positionRef.current = slidNumberTemp;
    currentPositionSet(slidNumberTemp);
    play();
  };
  var play = function play(ms) {
    if (ms === void 0) {
      ms = palyTime;
    }
    if (autoPlay) {
      var time = setInterval(() => {
        _stopPlay.current.after == null || _stopPlay.current.after(positionRef.current);
        positionRef.current++;
        if (positionRef.current >= childCount) {
          positionRef.current = 0;
        }
        currentPositionSet(positionRef.current);
        _stopPlay.current.before == null || _stopPlay.current.before(positionRef.current);
      }, ms);
      _stopPlay.current.stop = () => {
        clearInterval(time);
      };
    }
  };
  useEffect(() => {
    play();
    return () => {
      _stopPlay.current.stop();
    };
  }, [autoPlay]);
  useEffect(() => {
    var time;
    if (childCount === currentPosition + 1) {
      time = setTimeout(() => {
        _stopPlay.current.before = () => {
          transitionInnerSet(scrollTime * 0.001 + "s ease-in-out");
          _stopPlay.current.before = props.beforeChange;
        };
        transitionInnerSet('none');
        gotoSlide(0);
      }, scrollTime);
    }
    return () => {
      clearTimeout(time);
    };
  }, [currentPosition]);
  var childrens = React.Children.map(props.children, child => {
    return /*#__PURE__*/_jsx("div", {
      style: _extends({
        width,
        height
      }, style),
      children: child
    });
  });
  var innerStyle = useMemo(() => {
    var style = {
      transform: '',
      display: ''
    };
    switch (direction) {
      case 'horizontal':
        style.transform = "translate3d(" + -(currentPosition * width) + "px, 0px, 0px)";
        style.display = 'flex';
        break;
      case 'vertical':
        style.transform = "translate3d(0px, " + -(currentPosition * height) + "px, 0px)";
        style.display = 'block';
        break;
      default:
        break;
    }
    return style;
  }, [direction, currentPosition, width, height]);
  return /*#__PURE__*/_jsx("div", {
    className: cls,
    style: {
      width,
      height
    },
    children: /*#__PURE__*/_jsxs("div", {
      className: cls + "-content",
      style: _extends({
        width: width * childCount,
        transition: transitionInner
      }, innerStyle),
      children: [childrens, /*#__PURE__*/_jsx("div", {
        style: _extends({
          width,
          height
        }, style),
        children: childrens == null ? void 0 : childrens[0]
      })]
    })
  });
}
export default /*#__PURE__*/React.forwardRef(Carousel);